<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
    </v-row>

    <v-row class="no-gutters mt-3" v-if="aDataExpandPerfil.length>0 && !bCargandoPerfiles">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <v-expansion-panels
          v-if="!bLoaderExpander"
          v-model="panels"
          focusable>
          <PerfilExpander
            v-for="(item, idx) in aDataExpandPerfil" :key="'itemExpand-'+idx"
            :oDataExpander="item"
            :sIdPerfil="item.idPerfil"
            @onActualizar="onActualizar"
            />
        </v-expansion-panels>
        <v-skeleton-loader v-else type="article, card-heading"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="no-gutters mt-3" v-else-if="!bCargandoPerfiles">
      <v-col cols="12"  class="text-center pa-1 under-sec-flat-gray">
        <v-card
          class="text-center">
          <v-card-text class="text-info mt-4">
            <v-icon color="primary" class="animated bounceIn dura-1" size="60px">mdi-information</v-icon>
            <h2 class="text-medium text-primary font-size-1">
              Sin información para mostrar
            </h2>
            <h2 class="text-medium text-primary font-size-1">
             Actualmente no existen perfiles PQR configurados para este modulo.
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axiosServices from '@/services/axiosServices.js'
import mxFunciones from '@/mixins/funciones.js'
import PerfilExpander  from '@/components/Seif/pqr/perfilExpander.vue'
// import DialogFirmas from '@/components/DialogFirmas.vue' 

export default {
  name: 'perfilPQR',
  components: {
    PerfilExpander
  },
  mixins: [mxFunciones],
  data() {
    return {
      tituloGrids:'',
      bLoaderExpander: false,
      bCargandoPerfiles: true,
      panels:null,
      aDataExpandPerfil:[],
      TablaName : 'PQR_Perfiles_Acciones',    // Nombre de la tabla a trabajar
    }
  },
  async mounted() {
    this.bLoaderExpander = true
    this.tituloGrids = await this.getTitulo(this.TablaName)
    this.onValidarTokenSinLogin()
    this.onValidarPerfilesEstados()
  },
  methods: {
    changeExpander(){
      return false
    },
    async onValidarPerfilesEstados() {
      this.bCargandoPerfiles = true
      const aResponse = await axiosServices.postConfiguration('pqr/perfil-pqr/verificacion', {}, true);
      if(aResponse.nStatusCode === 200){
        const aResponse2 = await axiosServices.getConfiguration('pqr/perfiles', true);
        this.bLoaderExpander = false
        this.bCargandoPerfiles = false
        if(aResponse2.nStatusCode === 200) {
          this.aDataExpandPerfil= []
          aResponse2.aData.forEach(oItem =>  {
            this.aDataExpandPerfil.push({
              titulo:oItem.NombrePerfil,
              acciones:oItem.cantidad,
              subtitulo:'Acciones activas',
              idPerfil: oItem.idPQR_Perfil
            })
          })

        }
      }else{
        this.bCargandoPerfiles = false
      }
    },
    async onActualizar(sIdPerfil){
      const aResponse2 = await axiosServices.getConfiguration('pqr/perfiles', true);
        this.bLoaderExpander = false
        if(aResponse2.nStatusCode === 200) {
          const aData = aResponse2.aData.filter(oItem => oItem.idPQR_Perfil === sIdPerfil)
          const nIndex = this.aDataExpandPerfil.findIndex(oItem => oItem.idPerfil === sIdPerfil)
          this.aDataExpandPerfil[nIndex].acciones = aData[0].cantidad            
        }
    }
  },
  watch: {
    panels(){
      //console.log(this.panels)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>